import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { RootState } from '../../store/store'
import { AdminModeState } from '../adminMode/definitions'

export type Realm = 'fic' | 'dic' | 'resellers' | 'dic-es'

export const isRealm = (value: string): value is Realm => {
  if (!value) return false
  return ['fic', 'dic', 'resellers', 'dic-es'].indexOf(value) !== -1
}
const isAdmin = (value: string) => {
  const isLogged = JSON.parse(value) as AdminModeState
  return isLogged['value']
}

const getInitValue = (): Realm => {
  const serialisedState = localStorage.getItem('hcAdminModeState')
  if (!serialisedState || !isAdmin(serialisedState)) {
    if (origin.endsWith('reseller.madbit.it')) {
      return 'resellers'
    }
    if (origin.endsWith('.dipendentincloud.it')) {
      return 'dic'
    }
    if (origin.endsWith('.gestiondeempleados.com')) {
      return 'dic-es'
    }
  } else {
    const adminRealm = localStorage.getItem('hcRealmState')
    if (adminRealm) {
      const json = JSON.parse(adminRealm) as RealmState
      return json.value
    }
  }
  return 'fic'
}

export interface RealmState {
  value: Realm
}

export const realmSlice = createSlice({
  name: 'realm',
  initialState: {
    value: getInitValue(),
  },
  reducers: {
    setRealm: (state, { payload }: PayloadAction<RealmState>) => {
      state.value = payload.value
    },
  },
})

export const { setRealm } = realmSlice.actions
export const selectRealm = (state: RootState): string => state.realm.value
export default realmSlice.reducer
